// Shared Google Sheets write helper used by all tabs that mutate data.
// Uses Apps Script URL + token from localStorage. mode: 'no-cors' means
// we can't see the response — success is assumed if no network error.

export async function writeToSheet(
  action: 'append' | 'update' | 'delete',
  tab: string,
  data: Record<string, unknown>,
): Promise<boolean> {
  const url   = localStorage.getItem('meridian_script_url') ?? '';
  const token = localStorage.getItem('meridian_token') ?? '';
  if (!url) {
    import('./toast').then(m => m.showToast('⚠️ Apps Script URL not set. Go to Admin to configure.', 'warn'));
    return false;
  }
  try {
    await fetch(url, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ action, tab, data, token }),
      mode:    'no-cors',
    });
    return true;
  } catch {
    import('./toast').then(m => m.showToast('❌ Write failed. Check Apps Script URL.', 'error'));
    return false;
  }
}
